<template>
    <v-list density="compact" class="notifications-list">
        <h2
            v-if="!landingPageNotifications.length"
            class="notifications-list__no-notifications-label"
        >
            {{ toSentenceCase($tkey('noNotifications')) }}
        </h2>
        <v-list-item
            v-for="notification in landingPageNotifications.slice(0, 20)"
            :key="notification._id"
            class="notification"
            @click="handleNotificationClick(notification)"
        >
            <template v-slot:append>
                <v-icon size="33" color="primary"> mdi-chevron-right </v-icon>
            </template>

            <v-list-item-subtitle
                v-for="row in notification.entityDisplayConfig"
                :key="row.entity"
                class="notification__title"
            >
                <b>{{ suffixWithColon(toSentenceCase($t(`${row.prefix}`, 1))) }}</b>
                <v-tooltip :text="getDetails({ notification, rowDetails: row })"
                    >`
                    <template v-slot:activator="{ props }">
                        <span v-bind="props" class="notification__title-text">
                            {{ getDetails({ notification, rowDetails: row }) }}
                        </span>
                    </template>
                </v-tooltip>
            </v-list-item-subtitle>
            <v-list-item-subtitle class="notification__content">
                {{ $t(`landingPageNotifications.${notification.messageKey}`) }}
            </v-list-item-subtitle>
            <v-list-item-subtitle class="notification__content">
                {{ dateTime(notification.lastUpdatedOn) }}
            </v-list-item-subtitle>
        </v-list-item>
    </v-list>
</template>

<script>
import { pick, get } from 'lodash';
import { mapState, mapGetters, mapActions } from 'vuex';
import resources from '@enums/resources';

export default {
    localizationKey: 'landing.notifications',
    props: {
        sidebar: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            resourceToResourceIdMap: {
                [resources.promotions]: 'promotionId',
            },
        };
    },
    computed: {
        ...mapState('clientConfig', ['notificationsConfig']),
        ...mapGetters('notifications', ['landingPageNotifications']),
    },
    methods: {
        ...mapActions('notifications', ['closeNotification']),
        async handleNotificationClick(notification) {
            const notificationConfig = this.notificationsConfig.find(
                c => c.notificationKey === notification.notificationKey
            );
            const closeOnClick = notificationConfig.closeOnClick;
            if (closeOnClick) {
                const resource = notificationConfig.resource;
                const resourceIdField = this.resourceToResourceIdMap[resource];
                const resourceId = get(notification, `details.entityIds.${resourceIdField}`);
                this.closeNotification({
                    notificationKey: notification.notificationKey,
                    resource,
                    resourceId,
                });
            }
            const routeEntityIds = pick(
                notification.details.entityIds,
                notificationConfig.routeEntityIds
            );
            this.$router.push({ name: notificationConfig.routeName, params: routeEntityIds });
        },
        getDetails({ notification, rowDetails }) {
            return get(notification, rowDetails.path);
        },
    },
};
</script>

<style scoped lang="scss">
@import '@style/base/_variables.scss';
.notifications-list {
    padding-top: 0;
    overflow: visible;
    .notification {
        border-bottom: 0.1rem solid $promo-divider-colour;

        :deep(.v-list-item__spacer) {
            width: 1rem;
        }

        &__title {
            display: flex;
            gap: 0.2rem;
            font-size: 1.3rem;
            width: 100%;
            line-height: 1.5rem;
            color: rgba(0, 0, 0, 0.6);
            overflow: hidden;
            white-space: nowrap;
        }
        &__title-text {
            flex: 1;
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        &__content {
            display: flex;
            white-space: initial;
            font-size: 1.2rem;
            width: 100%;
            line-height: 1.4rem;
            color: rgba(0, 0, 0, 0.6);
        }
        &__icon {
            align-self: auto;
        }
    }
    &__no-notifications-label {
        color: $promo-text-colour;
        font-weight: normal;
        padding: 2rem;
    }

    .v-list-item--density-default.v-list-item--one-line {
        padding-top: 0;
        padding-bottom: 0;
    }
}
</style>
